import React from 'react'
import styled from 'styled-components'

import { desktopVw } from '../../styles/utils'
import { isLoggedIn } from '../../utils'

import { Input, Container } from '../FormElements'
import Button from '../Button'

import ReferralPoints from './ReferralPoints'
import { ReferralFormHeader, StyledButton } from './ReferralStyle'

const Form = styled.form`
  margin-bottom: 42px;
  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(44)};
  }
`

const ActivateAccount = styled(Button)`
  padding: 22px;
  margin-bottom: 30px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(30)};
    padding: ${desktopVw(11)} ${desktopVw(50)};
  }
`

const ReferralPointsContainer = styled.div`
  border-top: 1px solid ${props => props.theme.colors.greyLighter};
  margin-bottom: 96px;
  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(350)};
  }
`

const ReferralPointsWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.greyLighter};
`

const StyledInput = styled(Input)`
  height: 50px;
  width: 314px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    width: ${desktopVw(350)};
  }
`

const Success = ({
  handleSubmit,
  handleChange,
  referralCode,
  targetEmail,
  successfulReferrals,
  invitedReferrals,
  submitButtonText,
  loading,
}) => {
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <ReferralFormHeader>
          <h1>
            <i>Thanks for referring!</i>
          </h1>
          <p>Remind your friends to check their email</p>
        </ReferralFormHeader>
        <Container>
          <StyledInput
            type="text"
            name="targetEmail"
            required
            value={targetEmail}
            placeholder="Your friend’s email (separated by commas)"
            onChange={handleChange}
          />
        </Container>
        <Container>
          <StyledButton type="submit" black loading={loading}>
            {submitButtonText}
          </StyledButton>
        </Container>
      </Form>
      <ReferralPointsContainer>
        <ReferralPointsWrapper>
          <ReferralPoints
            title="Successfully referred friends"
            referrals={successfulReferrals || []}
            totalText="Total earned points"
            noReferralsMsg="No successful referrals yet"
          />
        </ReferralPointsWrapper>
        {!isLoggedIn() && (
          <ActivateAccount
            black
            to="/sign-up"
            trackParams={{
              trackInternal: true,
              trackGA: true,
              category: 'referral',
              action: 'activate_account',
            }}
          >
            Activate your account to access rewards
          </ActivateAccount>
        )}
        <ReferralPointsWrapper>
          <ReferralPoints
            title="Your referrals"
            referrals={invitedReferrals || []}
            totalText="Total potential points"
            noReferralsMsg="No referrals yet"
          />
        </ReferralPointsWrapper>
      </ReferralPointsContainer>
    </>
  )
}

export default Success
